import { render, staticRenderFns } from "./DeleteConsigneeModalIcon.vue?vue&type=template&id=1536984d"
import script from "./DeleteConsigneeModalIcon.vue?vue&type=script&lang=js"
export * from "./DeleteConsigneeModalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports